import CollectionItem from './CollectionItem'

export default interface Collection<I extends CollectionItem | unknown = unknown> {
  // Collection Formatter
  name: string
  id: number
  description: string | null
  public: boolean
  query: string | null
  button_label: string | null
  is_title_collection: boolean
  is_marketplace_collection: boolean
  is_collection_of_collections: boolean
  collection_image_id: number | null
  url: string
  blur_hash: string | null

  /** Needs to be included into packaged data {:count => true} */
  document_count?: number

  /** Needs to be included into packaged data {:items => true} */
  items?: I[]

  // TODO: Move this out of object (only present on titles collection request)
  type?: string
}

export enum CollectionType {
  COLLECTION = 'CollectionCollection',
  PRODUCT = 'CollectionProduct',
  CONTENT_TITLE = 'CollectionContentTitle',
  DOCUMENT = 'CollectionDocument',
}
